import { render, staticRenderFns } from "./ScheduleCalendar.vue?vue&type=template&id=366bb947"
import script from "./ScheduleCalendar.vue?vue&type=script&lang=js"
export * from "./ScheduleCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ScheduleCalendar.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('366bb947', component.options)
    } else {
      api.reload('366bb947', component.options)
    }
    module.hot.accept("./ScheduleCalendar.vue?vue&type=template&id=366bb947", function () {
      api.rerender('366bb947', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/views/schedule/ScheduleCalendar.vue"
export default component.exports